// extracted by mini-css-extract-plugin
export default {"slider":"Courses_slider__PbI0M","sliderTrack":"Courses_sliderTrack__nLAr0","scroll":"Courses_scroll__Y9r3+","slide":"Courses_slide__RR7P1"};